// These pages already explain the common safeguards in their main text and
// review checklist. A repeated three-question sales/safeguard FAQ adds no answer.
const sharedAdultFaqPages = new Set([
  "adult-seo", "adult-ai-search-optimization", "fan-platform-marketing",
  "creator-agency-services", "compliance", "age-verification", "performer-consent",
  "payment-processor", "platform-policy", "aup-explainer",
  "adult-reputation-management", "mainstream-platform-brand-safe-strategy",
]);

export function hasAdultTopicFaqs(slug: string): boolean {
  return !sharedAdultFaqPages.has(slug);
}

export function hasDistinctAiDefinition(slug: string): boolean {
  return !["what-is-geo", "what-is-aeo", "geo-vs-seo"].includes(slug);
}

const adultPolicyHosts: Readonly<Record<string, readonly string[]>> = {
  "adult-seo": ["developers.google.com"],
  "adult-ai-search-optimization": ["developers.google.com"],
  "adult-reputation-management": ["developers.google.com"],
  "onlyfans-marketing": ["onlyfans.com"],
  "fanvue-growth": ["fanvue.com"],
  "fansly-strategy": ["fansly.com"],
  "pornhub-seo": ["pornhub.com"],
  "reddit-promotion": ["reddit.com", "redditinc.com"],
  "tiktok-adult-safe": ["tiktok.com"],
  "instagram-adult-safe": ["meta.com", "facebook.com", "instagram.com"],
  "youtube-shorts-adult-safe": ["youtube.com", "support.google.com"],
};

export function isRelevantAdultReference(slug: string, url: string): boolean {
  try {
    const host = new URL(url).hostname;
    return (adultPolicyHosts[slug] ?? []).some((allowed) => host === allowed || host.endsWith(`.${allowed}`));
  } catch {
    return false;
  }
}
